// Listing verdict from a valuation BAND, not a point estimate. The model's
// held-out P10–P90 is the range comparable units actually sell in; inside it,
// price differences are noise the model can't explain (facing, renovation,
// view), so the verdict is CONSIDER. Only an asking price outside the band is
// a signal. (The old rule called BUY at 3% below the point estimate, which
// 36% of fairly-priced units crossed by chance in testing.)

export type Verdict = "buy" | "consider" | "pass";

export interface VerdictInput {
  asking: number;
  fair: number; // P50
  p10?: number;
  p90?: number;
  affordable: boolean;
  entryScore: number | null; // market-timing score (untested prior; can only downgrade)
}

export interface VerdictResult {
  verdict: Verdict;
  gap: number; // asking / fair − 1 (negative = below fair)
  position: "below-band" | "in-band" | "above-band";
}

export function listingVerdict(inp: VerdictInput): VerdictResult {
  const gap = inp.asking / inp.fair - 1;
  // Fallback band when a cached result predates bands: ±3% (the old rule).
  const p10 = inp.p10 ?? inp.fair * 0.97;
  const p90 = inp.p90 ?? inp.fair * 1.03;
  const position = inp.asking <= p10 ? "below-band" : inp.asking >= p90 ? "above-band" : "in-band";

  let verdict: Verdict = !inp.affordable ? "pass" : position === "below-band" ? "buy" : position === "above-band" ? "pass" : "consider";
  // The timing score is an untested mean-reversion prior (FINDINGS F-15), so it
  // may make the verdict more cautious but never promotes one to BUY.
  if (verdict === "buy" && inp.entryScore != null && inp.entryScore <= 40) verdict = "consider";
  return { verdict, gap, position };
}
